import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetMobilityVehiclesQueryVariables = Types.Exact<{
  customerId: Types.Scalars['bigint']['input'];
}>;


export type GetMobilityVehiclesQuery = { __typename?: 'query_root', mobility_vehicles: Array<{ __typename?: 'mobility_vehicles', id: number, vin?: string | null, make: string, model: string, year?: number | null, color?: string | null, license_plate?: string | null, status: string }> };


export const GetMobilityVehiclesDocument = gql`
    query getMobilityVehicles($customerId: bigint!) {
  mobility_vehicles(
    where: {customer_id: {_eq: $customerId}, status: {_in: ["available", "in_use"]}}
    order_by: {updated_at: desc}
  ) {
    id
    vin
    make
    model
    year
    color
    license_plate
    status
  }
}
    `;

/**
 * __useGetMobilityVehiclesQuery__
 *
 * To run a query within a React component, call `useGetMobilityVehiclesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMobilityVehiclesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMobilityVehiclesQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useGetMobilityVehiclesQuery(baseOptions: Apollo.QueryHookOptions<GetMobilityVehiclesQuery, GetMobilityVehiclesQueryVariables> & ({ variables: GetMobilityVehiclesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMobilityVehiclesQuery, GetMobilityVehiclesQueryVariables>(GetMobilityVehiclesDocument, options);
      }
export function useGetMobilityVehiclesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMobilityVehiclesQuery, GetMobilityVehiclesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMobilityVehiclesQuery, GetMobilityVehiclesQueryVariables>(GetMobilityVehiclesDocument, options);
        }
// @ts-ignore
export function useGetMobilityVehiclesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMobilityVehiclesQuery, GetMobilityVehiclesQueryVariables>): Apollo.UseSuspenseQueryResult<GetMobilityVehiclesQuery, GetMobilityVehiclesQueryVariables>;
export function useGetMobilityVehiclesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMobilityVehiclesQuery, GetMobilityVehiclesQueryVariables>): Apollo.UseSuspenseQueryResult<GetMobilityVehiclesQuery | undefined, GetMobilityVehiclesQueryVariables>;
export function useGetMobilityVehiclesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMobilityVehiclesQuery, GetMobilityVehiclesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMobilityVehiclesQuery, GetMobilityVehiclesQueryVariables>(GetMobilityVehiclesDocument, options);
        }
export type GetMobilityVehiclesQueryHookResult = ReturnType<typeof useGetMobilityVehiclesQuery>;
export type GetMobilityVehiclesLazyQueryHookResult = ReturnType<typeof useGetMobilityVehiclesLazyQuery>;
export type GetMobilityVehiclesSuspenseQueryHookResult = ReturnType<typeof useGetMobilityVehiclesSuspenseQuery>;
export type GetMobilityVehiclesQueryResult = Apollo.QueryResult<GetMobilityVehiclesQuery, GetMobilityVehiclesQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/mobileService/queries/getMobilityVehicles.query.gql}
 */
export async function getMobilityVehicles(
  variables: GetMobilityVehiclesQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetMobilityVehiclesQuery['mobility_vehicles']>
export async function getMobilityVehicles(
  variables: GetMobilityVehiclesQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetMobilityVehiclesQuery>
export async function getMobilityVehicles(
  variables: GetMobilityVehiclesQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetMobilityVehiclesQuery['mobility_vehicles'] | GetMobilityVehiclesQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetMobilityVehiclesQuery>(
    GetMobilityVehiclesDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.mobility_vehicles
}